import { Box } from "@primer/react";
import DashBoardPage from "../dashboard";
const HomePage = () => {

  return (
    <Box>
      <DashBoardPage />
    </Box>

  );
}
export default HomePage
